import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import storage from './storageIdb';

// slices
import authSlice from './authSlice';
import dashboardFilterSlice from './dashboardFilterSlice';
import resetSlice from './resetSlice';
import mdCoverageSlice from './mdCoverageSlice';
import mdConcentrationSlice from './mdConcentrationSlice';
import mdReachSlice from './mdReachSlice';
import hydrationSlice from './hydrationSlice';
import stratClassSlice from './stratClassSlice';

// rehydrate
const useStore = create(
  persist(
    (...a) => ({
      ...authSlice(...a),
      ...dashboardFilterSlice(...a),
      ...mdCoverageSlice(...a),
      ...mdConcentrationSlice(...a),
      ...mdReachSlice(...a),
      ...resetSlice(...a),
      ...hydrationSlice(...a),
      ...stratClassSlice(...a),
    }),
    {
      name: 'sfe-manager-storage', // unique name
      storage: createJSONStorage(() => storage),
      onRehydrateStorage: () => (state) => {
        state.setHasHydrated(true);
      },
    },
  ),
);

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Store', useStore);
}

export default useStore;
